module.exports = __webpack_public_path__ + "images/icons_v2/values-do-right-bbf04ba0.svg";